import { h } from 'preact';

import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

import Skeleton from '@mui/material/Skeleton';
import { Avatar } from './_common.js';

export default function LazyPropertyRecord(_props) {
  return (
    <TableRow hover>
      <TableCell>
        <Avatar>
          <Skeleton variant="circular" height={56} width={56} />
        </Avatar>
      </TableCell>
      <TableCell>
        <Typography variant="h6">
          <Skeleton width={120}></Skeleton>
        </Typography>
      </TableCell>
    </TableRow>
  );
}
